import { render } from "./WorkWithUs.vue?vue&type=template&id=1438d688"
import script from "./WorkWithUs.vue?vue&type=script&lang=js"
export * from "./WorkWithUs.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/mcd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__